import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";

const ActionDialog = ({ open, onClose, action, onAction, actionItem }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <DialogContentText sx={{ fontWeight: "bold", mb: 2 }}>
          Are you sure?
        </DialogContentText>
        <DialogContentText sx={{ mb: 2 }}>
          Do you really want to{" "}
          <span style={{ fontStyle: "italic", fontWeight: "bold" }}>
            {action}
          </span>{" "}
          this {actionItem}?
        </DialogContentText>
        <DialogActions>
          <Button
            sx={{
              color: "gray",
              border: "1px solid gray",
              ":hover": { color: "gray", border: "1px solid gray" },
            }}
            variant="outlined"
            color="info"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={onAction}>
            {action}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ActionDialog;
